import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import moduleConstant from '../../common/module-constant';
import EventBus from '../../utils/event-bus';

@Component({
	name: 'Sidebar',
	template: require('./sidebar-template.html'),
	components: {
        // "favourite-list-component": () => import('../../containers/favourites/list/FavouriteFilterListComponent.vue'),
        "favourite-list-component": () => import('../../containers/favourites/selectbox/FavouriteFilterSelectboxComponent.vue'),
		"property-search": () => import("../../containers/property/PropertySearchComponent.vue"),
		"person-search": () => import("../../containers/person/components/person-search/PersonSearchComponent.vue"),
		"demand-search": () => import("../../containers/demand/components/demand-search/DemandSearchComponent.vue"),
		"task-search": () => import("../../containers/task/components/task-filter/TaskFilterComponent.vue")
	}
})
export default class Sidebar extends Vue {
	@Prop({ required: true }) moduleType: number;
	isCollapse: boolean = false;
	filterVisible: boolean = false;

	component: string = null;
	isShow: boolean = false;

    get buttonPosition() {
        return `${window.innerHeight - 300}px`;
    }

	handleColapseFilter() {
		this.isCollapse = !this.isCollapse;
	}

	handleVisibleSidebar(value) {
		this.filterVisible = value;
	}

	handleOpenFilter() {
		this.isShow = !this.isShow;
	}

	handleCloseMenu() {
		if (this.isShow) this.isShow = false;

	}

	private getFilterComponent() {
		switch (this.moduleType) {
			case moduleConstant.Object:
				this.component = "property-search";
				this.filterVisible = true;
				break;
			case moduleConstant.Person:
				this.component = "person-search";
				this.filterVisible = true;
				break;
			case moduleConstant.Demand:
				this.component = "demand-search";
				this.filterVisible = true;
				break;
			case moduleConstant.Task:
				this.component = "task-search";
				this.filterVisible = true;
				break;
			default:
				this.component = null;
				this.filterVisible = false;
				break;
		}
	}
	mounted() {
		this.getFilterComponent();
    }
    
    @Watch('isShow')
    handleChangeDisplayFilter(val) {
        EventBus.$emit('COLLAPSE_FILTER', val);
    }
}